type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'BankAccount'
const nameSource = '/financial/bankAccounts'
const namePageTitle = 'bankAccounts'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'bankAccounts',
  to: '/financial/bankAccounts',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/bankAccounts/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/bankAccounts/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/bankAccounts/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
